<div class="ca-login-content">
    <div class="ca-login-card">
      <div class="row">
        <div class="col-6 mt-4">
          <h3>{{'MENU.PUBLICO.LOGIN' | translate}}</h3>
            <form [formGroup]="loginForm" class="row" #formDirective="ngForm" (ngSubmit)="login()">
              <ca-form-field class="col-12">
                <ca-label>{{'MENU.PUBLICO.USUARIO' | translate}}</ca-label>
                <input caInput formControlName="usuario" placeholder="{{'MENU.PUBLICO.USUARIO' | translate}}" type="text" required />
                <ca-error *ngIf="loginForm.controls['usuario'].errors?.required">El campo es requerido</ca-error>
              </ca-form-field>
              <ca-form-field class="col-12">
                <ca-label>{{'MENU.PUBLICO.PASSWORD' | translate}}</ca-label>
                <input caInput formControlName="password" placeholder="{{'MENU.PUBLICO.PASSWORD' | translate}}" type="password" required />
                <ca-error *ngIf="loginForm.controls['password'].errors?.required">El campo es requerido</ca-error>
              </ca-form-field>
              <div class="col-12 mt-3">
                <button
                type="submit"
                [disabled]="loginForm.invalid"
                ca-button>
                {{'MENU.PUBLICO.ENTRAR' | translate}}
                </button>
              </div>
            </form>
          </div>
          <div class="col-6">
            <div class="ca-login-bg"></div>
          </div>
        </div>
    </div>
</div>